export class DialogModelLiveSI{
    constructor(
      public data:any
    ) {}
  }